
<div
  id="app"
  class="wsk-root wsk-app ws-fields-arrangement"
  :class="'theme--' + theme"
>
  <q-layout view="lHh Lpr lFf">
    <ws-drawer v-if="sidePanel" v-model="sidePanel" class="layout-drawer" full-height-content>
      <component
        :is="item.name"
        v-for="item in loginStore.items"
        :key="item.name"
      />
    </ws-drawer>

    <q-page-container>
      <router-view>
        <div class="loader-wrapper ws-min-height-1000 full-width">
          <ws-spinner spinner-type="circular" width="20px" text="general.loading_msg" />
        </div>
      </router-view>
    </q-page-container>

    <portal-target name="layout-default">
      <!--
      This content can be located anywhere in App.
      search for </portal> with attribute "to" set to same name as here "name" attribute
      -->
    </portal-target>
  </q-layout>

  <theme-switcher v-if="$store.state.devUtils" />
</div>
